'use client';

import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

interface LoadingProps {
    className?: string;
    size?: number;
}

export const Loading = ({ className, size = 24 }: LoadingProps) => {
    return (
        <div className={cn('flex h-full w-full items-center justify-center', className)}>
            <Loader2 className='text-purple animate-spin' size={size} />
        </div>
    );
};
